import React, { useState, useEffect } from 'react';
import styles from 'components/linearLoader/linearLoader.module.css';

const LinearLoader = () => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prev) => {
                // Move from 0 to 100
                if (prev >= 100) {
                    return 100;
                }
                return prev + 1;
            });
        }, 30);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles.loaderContainer}>
            <div className={styles.track}>
                <div
                    className={styles.progress}
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
};

export default LinearLoader;
